import { API_DATE_FORMAT } from '@ubeya/shared/constants';
import moment from 'moment';

export const agGridMomentFormatter = (value, format) => {
  return value ? moment(value).format(format) : '';
};

export const removeTimeFromDateString = (value) => {
  return value ? moment(value).format(API_DATE_FORMAT) : '';
};
